/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";

import { useCarousel } from "../../../../../hooks/useCarousel";
import { cssMediaQueryMinWidthTablet } from "../../../../../lib/constants/emotionMediaQueries.constants";
import { Carousel } from "../../../layout/Carousel/Carousel.emotion";
import type { CommunityTotalsStatisticCardsProps } from "./useCommunityTotalsStatisticsCards.emotion";
import { useCommunityTotalsStatisticCards } from "./useCommunityTotalsStatisticsCards.emotion";

const carouselStyle: Interpolation = {
  display: "flex",
  [cssMediaQueryMinWidthTablet]: { display: "none" },
};

export const CommunityTotalsStatisticCardsCarousel = ({
  id,
  metrics,
  range,
  selectedType,
  onSelectMetric,
}: CommunityTotalsStatisticCardsProps) => {
  const { statisticCards } = useCommunityTotalsStatisticCards({
    id,
    metrics,
    range,
    selectedType,
    onSelectMetric,
  });
  const carouselApi = useCarousel({
    pageOffset: [
      [24, 24],
      [24, 24],
    ],
    size: [2, 2, 2, 2, 2, 2],
  });

  return (
    <Carousel carouselApi={carouselApi} containerCSS={carouselStyle}>
      {statisticCards}
    </Carousel>
  );
};

CommunityTotalsStatisticCardsCarousel.displayName =
  "CommunityTotalsStatisticCardsCarousel";
